
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/statistics/transactions",
      function () {
        return require("private-next-pages/[locale]/statistics/transactions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/statistics/transactions"])
      });
    }
  